import { initialize as ldClientInitialize } from 'launchdarkly-js-client-sdk';
import camelCase from 'lodash.camelcase';

import { FeatureFlagConfigService } from '../feature-flag-config-service';
import { setFlags as setFlagsAction } from './actions';
import { getClientSideId, getOptions } from '../config';
import { LogService } from '../../services/log-service';

const flags = FeatureFlagConfigService.buildFlagConfig();

export const getFlagsFromLdClient = () => {
  const initialFlagValues = { isLDReady: true };
  const flagValues = Object.entries(flags).reduce((acc, [flag, defaultValue]) => {
    const flagKey = camelCase(flag);
    return {
      ...acc,
      [flagKey]: window.ldClient.variation(flag, defaultValue),
    };
  }, initialFlagValues);

  return flagValues;
};

const updateFlagsWithInitialValueFromLaunchDarkly = (ldClient, dispatch) => {
  const initialFlagValues = { isLDReady: true };
  const errors = [];

  const flagValues = Object.entries(flags).reduce((acc, [flag, defaultValue]) => {
    const flagKey = camelCase(flag);
    const variationDetail = ldClient.variationDetail(flag, defaultValue);

    if (variationDetail.reason?.errorKind) {
      errors.push({ flagKey, error: variationDetail.reason });
    }

    return {
      ...acc,
      [flagKey]: variationDetail.value,
    };
  }, initialFlagValues);

  dispatch(setFlagsAction(flagValues));

  if (errors.length) {
    LogService.logInfo('launch darkly returned variation errors', errors);
  }
};

const subscribeToChanges = (ldClient, dispatch) => {
  Object.keys(flags).forEach((flag) => {
    const flagKey = camelCase(flag);
    ldClient.on(`change:${flag}`, (newFlagValue) => {
      dispatch(
        setFlagsAction({
          [flagKey]: newFlagValue,
        }),
      );
    });
  });
};

export const initFeatureFlags = ({ user, ldOptions = getOptions() }) => {
  return new Promise((resolve) => {
    if (window.ldClient) {
      resolve();
      return;
    }

    window.ldClient = ldClientInitialize(getClientSideId(), user, ldOptions);
    window.ldClient.on('ready', () => {
      resolve();
    });
  });
};

export const setUpDispatching = (dispatch) => {
  updateFlagsWithInitialValueFromLaunchDarkly(window.ldClient, dispatch);
  subscribeToChanges(window.ldClient, dispatch);
};
